import leaderShipCardConfig from 'molecules/LeaderShipCard/config';

import type { Input } from '@builder.io/sdk';

const leaderShipDeckFields = [
  {
    name: 'enableRandomization',
    type: 'boolean',
    defaultValue: false,
  },
  {
    name: 'cardToStartRandomization',
    type: 'number',
    defaultValue: 3,
    showIf: "options.get('enableRandomization') === true",
  },
  {
    name: 'heading',
    type: 'richText',
  },
  {
    name: 'type',
    type: 'string',
    enum: ['Square', 'Short', 'Tall'],
    defaultValue: 'Square',
  },
  {
    name: 'leadershipCards',
    type: 'list',
    subFields: leaderShipCardConfig.inputs,
  },
  {
    name: 'footerNotes',
    type: 'richText',
  },
] as const satisfies DeepReadonly<Input[]>;

const leaderShipDeckConfig = {
  name: 'Leadership Deck',
  inputs: leaderShipDeckFields,
};

export type LeaderShipDeckProps = GenerateBuilder<typeof leaderShipDeckFields>;

export default leaderShipDeckConfig;
